var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M4.5 17.25V6.75M19.5 6.75V17.25M20.25 3.75H3.75C3.33579 3.75 3 4.08579 3 4.5V6C3 6.41421 3.33579 6.75 3.75 6.75H20.25C20.6642 6.75 21 6.41421 21 6V4.5C21 4.08579 20.6642 3.75 20.25 3.75zM12 17.25V20.25M12 23.25C12.8284 23.25 13.5 22.5784 13.5 21.75 13.5 20.9216 12.8284 20.25 12 20.25 11.1716 20.25 10.5 20.9216 10.5 21.75 10.5 22.5784 11.1716 23.25 12 23.25zM3 17.25H21", stroke: "#303030", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })
  );
});